export default __webpack_public_path__ + "static/consistent-header-slide-out-menu-7f16f0f7a33aa6642351e51a2861ff64.png";